import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import Apply from '../views/Apply.vue'
import Detail from '../views/Detail.vue'
import Print from '../views/Print.vue'
import History from '../views/history.vue'
import ApplyHome from '../views/ApplyHome.vue'
import ApplyActive from '../views/ApplyActive.vue'
import ApplyUpdataForm from '../views/ApplyUpdataForm.vue'
import ApplyPromise from '../views/ApplyPromise.vue'
import PrintLoad from '../views/PrintLoad.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
    // 路由懒加载
    // component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/Register',
    component: Register
  },
  {
    path: '/Apply',
    component: Apply
  },
  {
    path: '/Detail',
    component: Detail
  },
  {
    path: '/Print',
    component: Print
  },
  {
    path: '/History',
    component: History
  },
  {
    path: '/ApplyHome',
    component: ApplyHome
  },
  {
    path: '/ApplyActive',
    component: ApplyActive
  },
  {
    path: '/ApplyUpdataForm',
    component: ApplyUpdataForm
  },
  {
    path: '/ApplyPromise',
    component: ApplyPromise
  },
  {
    path: '/PrintLoad',
    component: PrintLoad
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path == '/' || to.path == '/Register' || to.path == '/Detail' || to.path == '/PrintLoad') return next() //eslint-disable-line
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/')
  next()
})

export default router
